import { Component } from '@angular/core';
import { ReplenishYourGoodBacteriaComponent } from '@components/consultation-request/upsells/replenish-your-good-bacteria/replenish-your-good-bacteria.component';

@Component({
  selector: 'app-replenish-your-good-bacteria-hsv',
  imports: [ReplenishYourGoodBacteriaComponent],
  templateUrl: './replenish-your-good-bacteria-hsv.component.html',
})
export class ReplenishYourGoodBacteriaHsvComponent {}
